import { createContext, useContext } from "react";
import { Calendar } from "../../models/calendar/Calendar.model";




export const CalendarsContext = createContext<{ calendars: Calendar[]; setCalendars: React.Dispatch<React.SetStateAction<Calendar[]>> } | undefined>(undefined);

export const useCalendars = () => {
  const context = useContext(CalendarsContext);
  if (!context) {
    throw new Error('useCalendars must be used within a CalendarContext.provider');
  }
  return context;
};